var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrowding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsNs: "&ns_ai;",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 130",
    style: {
      enableBackground: "new 0 0 60 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,7.5c-5.2,0-9.4,4.2-9.4,9.4c0,5.2,4.2,9.4,9.4,9.4c5.2,0,9.4-4.2,9.4-9.4C39.4,11.7,35.2,7.5,30,7.5z M19.6,28.7 c-6.7,0-12.1,5.4-12.1,12.1V70c0,2.3,1.8,4.1,4.1,4.1c2.3,0,4.1-1.8,4.1-4.1V43.7h2.1c0,0,0,68.8,0,73.3c0,3,2.5,5.5,5.5,5.5 c3.1,0,5.5-2.5,5.5-5.5V74.4h2.3V117c0,3,2.5,5.5,5.5,5.5c3.1,0,5.5-2.5,5.5-5.5V43.7h2.1V70c0,2.3,1.8,4.1,4.1,4.1 c2.3,0,4.1-1.8,4.1-4.1V40.8c0-6.7-5.5-12.1-12.1-12.1C40.4,28.7,19.6,28.7,19.6,28.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrowding);
export default __webpack_public_path__ + "static/media/crowding.26133c4583710c07e74d786851a90bfc.svg";
export { ForwardRef as ReactComponent };